import * as tslib_1 from "tslib";
import { Component } from "vue-property-decorator";
import { NumberInputControl } from "../../controls";
import H3InputNumber from '../shared/h3-input-number.vue';
import { InputNumber } from '@h3/antd-vue';
let NumberRangeInput = class NumberRangeInput extends NumberInputControl {
    get begin() {
        if (this.ctrl.value && this.ctrl.value.length > 0 && !isNaN(this.ctrl.value[0])) {
            return this.ctrl.value[0] ? Number(this.ctrl.value[0]) : this.ctrl.value[0];
        }
    }
    get end() {
        if (this.ctrl.value && this.ctrl.value.length === 2 && !isNaN(this.ctrl.value[1])) {
            return this.ctrl.value[1] ? Number(this.ctrl.value[1]) : this.ctrl.value[1];
        }
    }
    onBeginChange(value) {
        if (!this.ctrl.value || this.ctrl.value.length === 0) {
            this.ctrl.value = [value];
        }
        else {
            this.ctrl.value.splice(0, 1, value);
            this.ctrl.value = this.ctrl.value.slice();
        }
    }
    onEndChange(value) {
        if (!this.ctrl.value || this.ctrl.value.length === 0) {
            this.ctrl.value = [null, value];
        }
        else if (this.ctrl.value.length === 1) {
            this.ctrl.value.push(value);
            this.ctrl.value = this.ctrl.value.slice();
        }
        else {
            this.ctrl.value.splice(1, 1, value);
            this.ctrl.value = this.ctrl.value.slice();
        }
    }
};
NumberRangeInput = tslib_1.__decorate([
    Component({
        name: "input-number-range",
        components: {
            AInputNumber: InputNumber,
            H3InputNumber
        }
    })
], NumberRangeInput);
export default NumberRangeInput;
